import React from 'react'
import { Col, Panel, Rate, Row } from 'rsuite'
import { formatAverageRating } from '@@partner:helpers/product'
import ProductReviewsGrid from '../../productReview/ProductReviewGrid'
import type { GQL_ID } from '@@partner:types:graphql'

export interface ProductReviewsTabProps {
  brandSlug: string
  productId: GQL_ID
  averageRating?: number
  reviewCount?: number
}

export default function ProductReviewsTab ({
  brandSlug,
  productId,
  averageRating,
  reviewCount
}: ProductReviewsTabProps) {
  const productReviewsFilter = {
    fields: [ 'product_id' ],
    op: 'contains',
    value: [ Number(productId) ]
  }

  return (
    <Panel shaded className="my-5">
      <Row>
        <Col xs={24} className="flex mb-4">
          <Rate
            value={averageRating}
            readOnly
            size="xs"
            className="mb-6"
            allowHalf
          />
          <span>
            {averageRating} / {formatAverageRating(reviewCount || 0)}
          </span>
        </Col>
      </Row>
      <ProductReviewsGrid
        showIdsFilters={false}
        filter={productReviewsFilter}
        brandSlug={brandSlug}
      />
    </Panel>
  )
}
